<template>
    <b-modal ref="mdlConfigurazioneMagazzinoMarcaArticoli" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
        <b-row>
            <b-col cols="12" xs="12" sm="4" md="6" lg="6" xl="6">
                <label class="sa-label-data">Codice Azienda</label>
                <span v-if="isReadOnly"> {{ jsonDataMarcaArticolo.codiceAzienda }} </span>
                <b-form-input v-else v-model="jsonDataMarcaArticolo.codiceAzienda"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="4" md="6" lg="6" xl="6">
                <label class="sa-label-data">Marca</label>
                <span v-if="isReadOnly"> {{ jsonDataMarcaArticolo.marca }}</span>
                <b-form-input v-else v-model="jsonDataMarcaArticolo.marca"></b-form-input>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaMarcaArticolo">Salva</b-button>
            <b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            pathResource: "/magazzinoarticolimarche",
            isReadOnly: false,
            jsonDataMarcaArticolo: {
                id: null,
                codiceAzienda: null,
                marca: null,
            },
        };
    },
    mounted() {
        console.log("Componente attivo");
    },
    methods: {
        show(jsonDataMarcaArticolo, isReadOnly) {
            let me = this;
            me.jsonDataMarcaArticolo = jsonDataMarcaArticolo;
            me.isReadOnly = isReadOnly;

            if (isReadOnly) {
                me.title = "Visualizzazione Marca";
            } else {
                me.title = !jsonDataMarcaArticolo.id ? "Nuova Marca" : "Aggiorna Marca";
            }

            me.$refs.mdlConfigurazioneMagazzinoMarcaArticoli.show();
        },
        onCloseModal() {
            let me = this;
            me.jsonDataMarcaArticolo = {
                id: null,
                codiceAzienda: null,
                marca: null,
            };
            me.$emit("onCloseModal");
            me.$refs.mdlConfigurazioneMagazzinoMarcaArticoli.hide();
        },
        onClickSalvaMarcaArticolo() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataMarcaArticolo, me.salvaMarcaArticoloSuccess, me.salvaMarcaArticoloError);
        },
        salvaMarcaArticoloSuccess(response) {
            let me = this;
            me.$emit("saveMarcaArticolo", response);
            me.$refs.mdlConfigurazioneMagazzinoMarcaArticoli.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        salvaMarcaArticoloError(error) {
            let me = this;
            me.$emit("saveMarcaArticolo", error);
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onDeleteMarcaArticolo(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questa configurazione?", {
                    title: "Eliminazione Marca",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteMarcaArticolo(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        deleteMarcaArticolo(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteMarcaArticoloSuccess, me.deleteMarcaArticoloError);
        },
        deleteMarcaArticoloSuccess(response) {
            let me = this;
            me.$emit("marcaArticoloDelete", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteMarcaArticoloError(response) {
            let me = this;
            me.$emit("marcaArticoloDelete", response);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
